import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import RequireAuth from '../components/RequireAuth';
import ProveedorLayout from '../layouts/Proveedor';

const CotizarPage = lazy(() => import('../pages/proveedor/CotizarPage'));
const KanbanDashboard = lazy(() => import('../pages/proveedor/KanbanDashboard'));
const QuoteDetail = lazy(() => import('../pages/proveedor/QuoteDetail'));
const LinkedShops = lazy(() => import('../pages/proveedor/LinkedShops'));
const ProveedorProfile = lazy(() => import('../pages/proveedor/Profile'));
const ProveedorRegister = lazy(() => import('../pages/proveedor/Register'));

/**
 * Rutas públicas del proveedor — magic links + registro
 */
export const proveedorPublicRoutes = (
  <>
    <Route
      path="cotizar/:uuid"
      element={
        <Suspense fallback={null}>
          <CotizarPage />
        </Suspense>
      }
    />
    <Route
      path="registro"
      element={
        <Suspense fallback={null}>
          <ProveedorRegister />
        </Suspense>
      }
    />
  </>
);

/**
 * Rutas autenticadas del proveedor — requiere rol 'Provider'
 */
export const proveedorAuthRoutes = (
  <Route element={<RequireAuth allowedRoles={['Provider']} />}>
    <Route element={<ProveedorLayout />}>
      <Route path="portal" element={<Suspense fallback={null}><KanbanDashboard /></Suspense>} />
      <Route path="portal/:id" element={<Suspense fallback={null}><QuoteDetail /></Suspense>} />
      <Route path="talleres" element={<Suspense fallback={null}><LinkedShops /></Suspense>} />
      <Route path="perfil" element={<Suspense fallback={null}><ProveedorProfile /></Suspense>} />
    </Route>
  </Route>
);
